var map = {
	"./first-section-bg.jpg": "./src/assets/images/first-section-bg.jpg",
	"./fourth-section-bg.jpg": "./src/assets/images/fourth-section-bg.jpg",
	"./framework-logo.png": "./src/assets/images/framework-logo.png",
	"./jc3-bg.jpg": "./src/assets/images/jc3-bg.jpg",
	"./jc3mp-logo.png": "./src/assets/images/jc3mp-logo.png",
	"./logo.svg": "./src/assets/images/logo.svg",
	"./meow6.png": "./src/assets/images/meow6.png",
	"./meow7.png": "./src/assets/images/meow7.png",
	"./meow8.png": "./src/assets/images/meow8.png",
	"./nanos-framework.png": "./src/assets/images/nanos-framework.png",
	"./nav-background.jpg": "./src/assets/images/nav-background.jpg",
	"./projects.jpg": "./src/assets/images/projects.jpg",
	"./team/DepFeYwW4AE3__j.jpg": "./src/assets/images/team/DepFeYwW4AE3__j.jpg",
	"./team/alexanderG.jpg": "./src/assets/images/team/alexanderG.jpg",
	"./team/eduardS.jpg": "./src/assets/images/team/eduardS.jpg",
	"./team/gabrielN.jpg": "./src/assets/images/team/gabrielN.jpg",
	"./team/malteS.jpg": "./src/assets/images/team/malteS.jpg",
	"./world-logo.png": "./src/assets/images/world-logo.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";